import { X } from 'lucide-react';

interface IconProps {
  className?: string;
  size?: number;
  strokeWidth?: number;
}

export function XIcon({ className = '', size = 24, strokeWidth = 1.5 }: IconProps) {
  return (
    <X
      width={size}
      height={size}
      strokeWidth={strokeWidth}
      className={className}
    />
  );
}
